import * as React from 'react';

import { createIcon } from '../Icon';
export const ActivityIcon = createIcon(
  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />,
  'ActivityIcon'
);
